import { InfoMessagePositionsEnum, InfoMessagesFragment, SearchResultsQuery } from '@websky/graphql';
import { Action, createAction, handleActions } from 'redux-actions';

interface InfoMessagesByFlightNumber {
	[flightNumber: string]: InfoMessagesFragment[];
}

interface InfoMessagesByDirections {
	[directionIndex: number]: InfoMessagesByFlightNumber;
}

export interface InfoMessagesState {
	byDirections: InfoMessagesByDirections;
}

type SearchResults = SearchResultsQuery['SearchResult'];

const setInfoMessages = createAction<SearchResults>('SET_INFO_MESSAGES');

const infoMessagesReducer = handleActions<InfoMessagesState, SearchResults>(
	{
		[setInfoMessages.toString()](state, action) {
			const newState: InfoMessagesState = { byDirections: {} };
			const { payload } = (action as unknown) as Action<SearchResults>;

			for (const [directionIndex, direction] of payload.flightDirections.entries()) {
				for (const leg of direction.legs) {
					if (!newState.byDirections[directionIndex]) {
						newState.byDirections[directionIndex] = {};
					}

					for (const segment of leg.segments) {
						newState.byDirections[directionIndex][segment.segment.flightNumber] = [];

						for (const message of segment.segment.messages) {
							if (
								message.positions?.some(position =>
									[
										InfoMessagePositionsEnum.upsaleEconomy,
										InfoMessagePositionsEnum.flight,
										InfoMessagePositionsEnum.flightPrice,
										InfoMessagePositionsEnum.flightSearch
									].includes(position)
								)
							) {
								newState.byDirections[directionIndex][segment.segment.flightNumber].push(message);
							}
						}
					}
				}
			}

			return newState;
		}
	},
	{
		byDirections: {}
	}
);

export default infoMessagesReducer;
export { setInfoMessages };
